import LegalDocumentPage from "./LegalDocumentPage.jsx";

const POLICY_CONTENT = {
  title: "Política de Privacidade - Tesourinhos",
  date: "Ultima atualizacao: 17 de Abril de 2026",
  sections: [
    {
      heading: "Em conformidade com a LGPD (Lei 13.709/2018)",
      subsections: [
        {
          subheading: "2.1. Dados coletados",
          subtext:
            "Nome, telefone, e-mail, endereco do atendimento, dados de pagamento, informacoes sobre a crianca como idade, rotina e cuidados.",
        },
        {
          subheading: "2.2. Finalidade",
          subtext:
            "Os dados sao utilizados para: Intermediacao do servico, comunicacao, seguranca das partes e cumprimento de obrigacoes legais.",
        },
        {
          subheading: "2.3. Compartilhamento",
          subtext:
            "Os dados podem ser compartilhados com a profissional cadastrada que prestar servico, plataformas de pagamento e autoridades legais, em caso de medida judicial.",
        },
        {
          subheading: "2.4. Armazenamento",
          subtext:
            "Os dados sao armazenados com seguranca e pelo tempo necessario a prestacao do servico, conforme preve a LGPD (Lei n 13.709/2018) em seu artigo 15.",
        },
        {
          subheading: "2.5. Direitos do usuario",
          subtext:
            "Voce pode acessar seus dados, corrigir informacoes e solicitar exclusao. Solicitacoes: [carla.tesourinhosadm@gmail.com]",
        },
        {
          subheading: "2.6. Seguranca",
          subtext:
            "A Tesourinhos e uma plataforma seria e comprometida com a integridade das partes envolvidas, portanto adota medidas tecnicas para proteger os dados, mas nao garante seguranca absoluta e total contra ataques externos.",
        },
      ],
    },
  ],
};

export default function PrivacyPolicyScreen() {
  return (
    <LegalDocumentPage
      title={POLICY_CONTENT.title}
      date={POLICY_CONTENT.date}
      sections={POLICY_CONTENT.sections}
      accent="rose"
    />
  );
}